class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector("summary");
    this.content = el.querySelector(".content");

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener("click", (e) => this.onClick(e));

    this.el.addEventListener('toggle', (e) => this.onToggle(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";

    if (this.isClosing || !this.el.open) {
      const groupName = this.el.getAttribute('name') || this.el.getAttribute('data-accordion-group');
      
      if (groupName) {
        const otherAccordions = document.querySelectorAll(`details[open]`);
        
        otherAccordions.forEach((otherEl) => {
          if (otherEl !== this.el) {
            const otherGroupName = otherEl.getAttribute('name') || otherEl.getAttribute('data-accordion-group');

            if (otherGroupName === groupName) {
              const otherInstance = accordionInstances.get(otherEl);
              if (otherInstance && !otherInstance.isClosing) {
                otherInstance.shrink();
              }
            }
          }
        });
      }
      
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  
  onToggle(e) {

    const groupName = this.el.getAttribute('name') || this.el.getAttribute('data-accordion-group');
    
    if (!this.el.open && !this.isClosing && groupName) {
      this.el.style.height = this.el.style.overflow = "";
    }
  }

  shrink() {
    this.isClosing = true;
    this.el.classList.add('is-closing');

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
        {
          height: [startHeight, endHeight]
        },
        {
          duration: 400,
          easing: "ease-out"
        }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
        this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
        {
          height: [startHeight, endHeight]
        },
        {
          duration: 400,
          easing: "ease-out"
        }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = "";

    if (!open) {
      this.el.classList.remove('is-closing');
    }

    if (open) {
      const isMobile = window.innerWidth <= 992;
      const hasNameAttribute = this.el.hasAttribute('name');

      if (isMobile && hasNameAttribute) {
        setTimeout(() => {
          this.el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 50);
      }
    }
  }
}

const accordionInstances = new Map();

document.querySelectorAll("details").forEach((el) => {
  const instance = new Accordion(el);
  accordionInstances.set(el, instance);
});

function updateAccordionNames() {
  const isMobile = window.innerWidth <= 992;
  const accordionItems = document.querySelectorAll('details[data-accordion-group]');

  accordionItems.forEach((item) => {
    const groupName = item.getAttribute('data-accordion-group');
    if (isMobile) {
      item.setAttribute('name', groupName);
    } else {
      item.removeAttribute('name');
    }
  });
}

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

updateAccordionNames();

window.addEventListener('resize', debounce(updateAccordionNames, 250));